import { Link, useNavigate } from "react-router-dom";
import { ssoLogout } from "../../services/auth.service";
import ICRCLogo from "../../assets/images/ICRC.svg";
import IFEMLogo from "../../assets/images/IFEM.png";
import GuideIcon from "../../assets/images/guide.svg";
import guidePdf from "../../assets/pdf/BEC_Training_Guide.pdf";
import "./Header.scss";
import AuiButton from "../Buttons/Buttons";
import { AdminRoles } from "../../utils/constants/app-constants";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import config from "../../config";

interface HeaderProps {
  showProfile: boolean;
}
const Header: React.FC<HeaderProps> = ({ showProfile }) => {
  const user = useSelector(
    (state: RootState) => state.user
  );
  const userRole = localStorage.getItem("role") ?? "";
  const certificateEnable = JSON.parse(
    localStorage.getItem("certificate_enabled") ?? "false"
  );
  const navigate = useNavigate();


  const handleRedirect = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!showProfile) {
      return;
    }
    e.preventDefault();
    if ([AdminRoles.SuperAdmin].includes(userRole as AdminRoles)) {
      navigate("/organization-listing");
    } else if (
      [
        AdminRoles.ApprovingAdmin,
        AdminRoles.SponsoringAdmin,
        AdminRoles.MasterTrainer,
      ].includes(userRole as AdminRoles)
    ) {
      navigate("/course-listing");
    } else {
      navigate("/");
    }
  };

  const navigateToUserConsent = () => {
    navigate("/user-consent");
  }

  return (
    <div className="header-wrapper">
      <aui-header headerbackground={true} stickyheader={true}>
        <a href="#main" className="skip-link">
          Skip to main content
        </a>
        <header className="aui-main-header">
          <div className="aui-header-row aui-header-container row d-flex align-items-center justify-content-end px-0">
            <div className="col-12 col-sm-6">
              <nav className="navbar navbar-expand-lg justify-content-between mx-auto aui-header-topbar aui-header-content aui-header-t">
                <Link
                  to="/"
                  className="aha-heart-logos position relative"
                  aria-label="ICRC and IFEM  Logo"
                  onClick={handleRedirect}
                >
                  <img
                    className="aui-desktop-logo d-lg-block"
                    src={ICRCLogo}
                    alt="ICRC logo"
                  />
                  <img
                    className="aui-desktop-logo d-lg-block"
                    src={IFEMLogo}
                    alt="IFEM logo"
                  />
                </Link>
              </nav>
            </div>
            <div className="col-6 col-sm-6">
              {showProfile && user.email && (
                <div className="d-flex aui-link-group justify-content-end">
                  <div className="d-flex flex-sm-row-reverse flex-lg-row align-items-center">
                    <a
                      className="guide-link"
                      href={guidePdf}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Open user guide"
                      title="User guide"
                    >
                      <img src={GuideIcon} alt="" aria-hidden="true" /> &nbsp; Guide
                    </a>
                    <ul className="navbar-nav d-flex flex-row align-items-center">
                      <li
                        id="lang"
                        className="nav-item pr-md-0 px-3 d-none d-sm-block aui-language-list position-relative"
                      >
                        <button
                          className="nav-link dropdown-toggle"
                          aria-label={user?.firstName + ' ' + user?.lastName}
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <aui-icon
                            svgclass="mr-1"
                            icon="avatarround"
                            svgwidth="20"
                            svgheight="20"
                          ></aui-icon>
                          <label className="mb-0" htmlFor="lang">
                            {user?.firstName + " " + user?.lastName}
                          </label>
                          <aui-icon
                            icon="arrowdown"
                            svgclass="ml-1"
                            svgwidth="12"
                            svgheight="12"
                          ></aui-icon>
                        </button>
                        <div className="dropdown-menu aui-header-dropdown position-absolute">
                          <ul className="loginoptionlist">
                            {[AdminRoles.SuperAdmin].includes(
                              userRole as AdminRoles
                            ) &&
                              certificateEnable && (
                                <li>
                                  <a
                                    className="dropdown-item"
                                    href="/certificate-listing"
                                  >
                                    Certificate
                                  </a>
                                </li>
                              )}
                            {[AdminRoles.ApprovingAdmin].includes(
                              userRole as AdminRoles
                            ) && (
                              <li>
                                <a
                                  className="dropdown-item"
                                  href="/user-consent-request"
                                >
                                  Consents
                                </a>
                              </li>
                            )}
                            {config.faqRequired && (
                              <li>
                                <a className="dropdown-item" href="/faq">
                                  FAQ
                                </a>
                              </li>
                            )}
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={ssoLogout}
                              >
                                Sign Out
                              </button>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                    <div
                      className="modal fade header-search-modal p-0"
                      id="searchModal"
                      tabIndex={-1}
                      aria-labelledby="searchModal"
                      aria-hidden="true"
                    >
                      <div className="w-100 mw-100 modal-dialog m-0">
                        <div className="modal-content">
                          <div className="modal-header border-bottom-0 p-4 text-right">
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <aui-icon
                                svgclass="mr-1"
                                icon="closeIcon"
                                svgwidth="16"
                                svgheight="16"
                              ></aui-icon>
                            </button>
                          </div>
                          <div className="modal-body mb-5">
                            <div className="form-inline flex-nowrap search-field mx-auto">
                              <label
                                className="mr-3"
                                htmlFor="inlineFormCustomSelect"
                              >
                                Search
                              </label>
                              <div className="input-group d-flex flex-nowrap align-items-center rounded-0 flex-grow-1">
                                <input
                                  className="form-control aui-search-box w-100"
                                  type="text"
                                  placeholder="Ex: Heart Attack Symptoms"
                                  aria-label="Search"
                                />
                                <div className="input-group-append">
                                  <span
                                    className="input-group-text search-icon-bg"
                                    id="basic-text1"
                                  >
                                    <aui-icon
                                      icon="search"
                                      svgclass="aui-search-icon text-white"
                                    ></aui-icon>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showProfile && (
                <div className="aui-mobile-lang aui-language-list position-relative d-flex align-items-center justify-content-end d-sm-none">
                  <button
                    className="nav-link dropdown-toggle py-2 my-1 my-md-0 username"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <aui-icon
                      svgclass="mr-1"
                      icon="avatarround"
                      svgwidth="20"
                      svgheight="20"
                    ></aui-icon>
                    {user.firstName + " " + user.lastName}
                    <aui-icon
                      icon="arrowdown"
                      svgclass="ml-1"
                      svgwidth="12"
                      svgheight="12"
                    ></aui-icon>
                  </button>
                  <div className="dropdown-menu aui-header-dropdown dropdown-menu-right position-absolute">
                    {[AdminRoles.ApprovingAdmin].includes(
                      userRole as AdminRoles
                    ) && (
                      <a className="dropdown-item" href="/user-consent-request">
                        Consents
                      </a>
                    )}
                    {config.faqRequired && (
                      <a className="dropdown-item" href="/faq">
                        FAQ
                      </a>
                    )}
                    {[AdminRoles.SuperAdmin].includes(userRole as AdminRoles) &&
                      certificateEnable && (
                        <a
                          className="dropdown-item"
                          href="/certificate-listing"
                        >
                          Certificate
                        </a>
                      )}
                    <a className="dropdown-item" href="/">
                      Sign Out
                    </a>
                  </div>
                </div>
              )}
              {window.location.pathname === "/" && (
                <div className="d-flex align-items-center justify-content-end p-3">
                  <AuiButton
                    variant="link-style-arrow"
                    buttontitle="User Consent Details"
                    buttonid="useId345"
                    buttonclass="userConsentLink"
                    onClick={navigateToUserConsent}
                  ></AuiButton>
                </div>
              )}
            </div>
          </div>
        </header>
      </aui-header>
    </div>
  );
};
export default Header;
